var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_546_5360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_546_5360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15C15.3472 15 15.6424 14.8785 15.8854 14.6354C16.1285 14.3924 16.25 14.0972 16.25 13.75C16.25 13.4028 16.1285 13.1076 15.8854 12.8646C15.6424 12.6215 15.3472 12.5 15 12.5C14.6528 12.5 14.3576 12.6215 14.1146 12.8646C13.8715 13.1076 13.75 13.4028 13.75 13.75C13.75 14.0972 13.8715 14.3924 14.1146 14.6354C14.3576 14.8785 14.6528 15 15 15ZM15 17.5C15.4167 17.5 15.8056 17.4028 16.1667 17.2083C16.5278 17.0139 16.8264 16.7431 17.0625 16.3958C16.7431 16.2014 16.4097 16.059 16.0625 15.9688C15.7153 15.8785 15.3611 15.8333 15 15.8333C14.6389 15.8333 14.2847 15.8785 13.9375 15.9688C13.5903 16.059 13.2569 16.2014 12.9375 16.3958C13.1736 16.7431 13.4722 17.0139 13.8333 17.2083C14.1944 17.4028 14.5833 17.5 15 17.5ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V9.75C17.2361 9.625 16.9653 9.51736 16.6875 9.42708C16.4097 9.33681 16.125 9.27083 15.8333 9.22917V4.16667H4.16667V15.8333H9.20833C9.25 16.1389 9.31597 16.4306 9.40625 16.7083C9.49653 16.9861 9.60417 17.25 9.72917 17.5H4.16667ZM4.16667 15.8333V4.16667V9.22917V9.16667V15.8333ZM5.83333 14.1667H9.22917C9.27083 13.875 9.33681 13.5903 9.42708 13.3125C9.51736 13.0347 9.61806 12.7639 9.72917 12.5H5.83333V14.1667ZM5.83333 10.8333H10.9167C11.3611 10.4167 11.8576 10.0694 12.4062 9.79167C12.9549 9.51389 13.5417 9.32639 14.1667 9.22917V9.16667H5.83333V10.8333ZM5.83333 7.5H14.1667V5.83333H5.83333V7.5ZM15 19.1667C13.8472 19.1667 12.8646 18.7604 12.0521 17.9479C11.2396 17.1354 10.8333 16.1528 10.8333 15C10.8333 13.8472 11.2396 12.8646 12.0521 12.0521C12.8646 11.2396 13.8472 10.8333 15 10.8333C16.1528 10.8333 17.1354 11.2396 17.9479 12.0521C18.7604 12.8646 19.1667 13.8472 19.1667 15C19.1667 16.1528 18.7604 17.1354 17.9479 17.9479C17.1354 18.7604 16.1528 19.1667 15 19.1667Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemography);
export default __webpack_public_path__ + "static/media/demography.ccc76eccdc618d67f45d9308d5d9b8a3.svg";
export { ForwardRef as ReactComponent };